<template>
  <div class="profile">
    <div class="main_left_content pc_orders">

      <Orders v-show="viewForm"/>

      <div class="edit_user_data" v-show="!viewForm">
        <div class="edit_user_data_l">
          <input type="text" autocomplete="off" v-model.trim="fio" placeholder="ФИО">
          <input type="text" autocomplete="off" v-model.trim="contact_phone" placeholder="Контактный телефон">
          <select v-model.trim="city_id">
            <option value="" :disabled="isDis" selected>Выберите город</option>
            <option
                v-for="cityArrId in cityArr"
                :key="cityArrId.id"
                :value="cityArrId.id"
            >
              {{ cityArrId.name }}
            </option>
          </select>

          <select v-model.trim="post_id">
            <option value="" :disabled="isDis" selected>Почтовое отделение</option>
            <option
                v-for="postArrId in postArr"
                :key="postArrId.id"
                :value="postArrId.id"
            >
              {{ postArrId.name }}
            </option>
          </select>
          <select v-model.trim="delivery_type">
            <option value="" :disabled="isDis" selected>Тип доставки</option>
            <option
                v-for="deliveryArrId in deliveryArr"
                :key="deliveryArrId.id"
                :value="deliveryArrId.id"
            >
              {{ deliveryArrId.name }}
            </option>
          </select>
          <button @click="saveDataUser">
                    <span v-show="!viewLoaderSave">
                        Сохранить
                    </span>
            <v-progress-circular v-show="viewLoaderSave" class="loader__color" indeterminate
                                 size="24"></v-progress-circular>
          </button>
        </div>
        <div class="edit_user_data_r">
          <input type="text" autocomplete="off"
                 :class="{'error_input': $v.old_password.$dirty && !$v.old_password.required}"
                 v-model.trim="old_password" placeholder="Старый пароль">
          <div class="error" v-if="$v.old_password.$dirty && !$v.old_password.required">Поле повторите пароль обязателен
            к заполнению
          </div>
          <div class="error" v-if="!$v.old_password.minLength">Минимальная длина пароля 4 символов.</div>

          <input type="text" autocomplete="off"
                 :class="{'error_input': $v.new_password.$dirty && !$v.new_password.required}"
                 v-model.trim="new_password" placeholder="Новый пароль">
          <div class="error" v-if="$v.new_password.$dirty && !$v.new_password.required">Поле пароль обязателен к
            заполнению
          </div>
          <div class="error" v-if="!$v.new_password.minLength">Минимальная длина пароля 4 символов.</div>
          <div class="error" v-if="!$v.confirm_new_password.sameAs">Пароли не совпадают</div>

          <input type="text" autocomplete="off"
                 :class="{'error_input': $v.confirm_new_password.$dirty && !$v.confirm_new_password.required}"
                 v-model.trim="confirm_new_password" placeholder="Повторите пароль">
          <div class="error" v-if="$v.confirm_new_password.$dirty && !$v.confirm_new_password.required">Поле повторите
            пароль обязателен к заполнению
          </div>
          <div class="error" v-if="!$v.confirm_new_password.sameAs">Пароли не совпадают</div>

          <button @click="changePassword">
                  <span v-show="!viewLoader">
                      Смените пароль
                  </span>
            <v-progress-circular v-show="viewLoader" class="loader__color" indeterminate
                                 size="24"></v-progress-circular>
          </button>
        </div>
      </div>
    </div>
    <div class="main_rigth_content">
      <div class="main_rigth_content_base_block">
        <button @click="signOut">
          Выйти с личного кабинета
        </button>
      </div>
      <div class="main_rigth_content_base_block">
        <p v-show="fioData != null">
          ФИО: <b>{{ this.fioData }}</b>
        </p>
        <p>
          Логин: <b>{{ this.login }}</b>
        </p>
        <p>
          Контактный тел. : <b>{{ this.contact_phone }}</b>
        </p>
        <p v-if="personal_discount == null || personal_discount == 0">
          Бонусы: <b>{{ this.bonuses }}</b> ₸
        </p>
        <p v-if="personal_discount != null && personal_discount != 0">
          Персональная скидка:
          <b v-show="personal_discount != null">{{ this.personal_discount }}</b>
          <b v-show="personal_discount == null">0</b>
          %
        </p>
      </div>
      <div class="main_rigth_content_base_block">
        <p>
          Если у вас возникли вопросы по заказу, дополнению или отмене заказа. Обратитесь в отдел продаж по номеру
          телефона
        </p>
        <p>
          <b>+7(707) 304 92 33</b> мы с удовольствием вам поможем.
        </p>
      </div>
      <div class="main_rigth_content_base_block">
        <button :class="{'active_btn': editBtn == true}" @click="edit_profile">
          Редактировать профиль
        </button>
      </div>
      <div class="main_rigth_content_base_block">
        <button :class="{'active_btn': listBtn == true}" @click="list_orders">
          Список заказов
        </button>
      </div>
    </div>
    <div class="main_left_content mob_orders">

      <Orders v-show="viewForm"/>

      <div class="edit_user_data" v-show="!viewForm">
        <div class="edit_user_data_l">
          <input type="text" autocomplete="off" v-model.trim="fio" placeholder="ФИО">
          <input type="text" autocomplete="off" v-model.trim="contact_phone" placeholder="Контактный телефон">
          <select v-model.trim="city_id">
            <option value="" :disabled="isDis" selected>Выберите город</option>
            <option
                v-for="cityArrId in cityArr"
                :key="cityArrId.id"
                :value="cityArrId.id"
            >
              {{ cityArrId.name }}
            </option>
          </select>

          <select v-model.trim="post_id">
            <option value="" :disabled="isDis" selected>Почтовое отделение</option>
            <option
                v-for="postArrId in postArr"
                :key="postArrId.id"
                :value="postArrId.id"
            >
              {{ postArrId.name }}
            </option>
          </select>
          <select v-model.trim="delivery_type">
            <option value="" :disabled="isDis" selected>Тип доставки</option>
            <option
                v-for="deliveryArrId in deliveryArr"
                :key="deliveryArrId.id"
                :value="deliveryArrId.id"
            >
              {{ deliveryArrId.name }}
            </option>
          </select>
          <button @click="saveDataUser">
                    <span v-show="!viewLoaderSave">
                        Сохранить
                    </span>
            <v-progress-circular v-show="viewLoaderSave" class="loader__color" indeterminate
                                 size="24"></v-progress-circular>
          </button>
        </div>
        <div class="edit_user_data_r">
          <input type="text" autocomplete="off"
                 :class="{'error_input': $v.old_password.$dirty && !$v.old_password.required}"
                 v-model.trim="old_password" placeholder="Старый пароль">
          <div class="error" v-if="$v.old_password.$dirty && !$v.old_password.required">Поле повторите пароль обязателен
            к заполнению
          </div>
          <div class="error" v-if="!$v.old_password.minLength">Минимальная длина пароля 4 символов.</div>

          <input type="text" autocomplete="off"
                 :class="{'error_input': $v.new_password.$dirty && !$v.new_password.required}"
                 v-model.trim="new_password" placeholder="Новый пароль">
          <div class="error" v-if="$v.new_password.$dirty && !$v.new_password.required">Поле пароль обязателен к
            заполнению
          </div>
          <div class="error" v-if="!$v.new_password.minLength">Минимальная длина пароля 4 символов.</div>
          <div class="error" v-if="!$v.confirm_new_password.sameAs">Пароли не совпадают</div>

          <input type="text" autocomplete="off"
                 :class="{'error_input': $v.confirm_new_password.$dirty && !$v.confirm_new_password.required}"
                 v-model.trim="confirm_new_password" placeholder="Повторите пароль">
          <div class="error" v-if="$v.confirm_new_password.$dirty && !$v.confirm_new_password.required">Поле повторите
            пароль обязателен к заполнению
          </div>
          <div class="error" v-if="!$v.confirm_new_password.sameAs">Пароли не совпадают</div>

          <button @click="changePassword">
                  <span v-show="!viewLoader">
                      Смените пароль
                  </span>
            <v-progress-circular v-show="viewLoader" class="loader__color" indeterminate
                                 size="24"></v-progress-circular>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Orders from '@/components/Orders'
import {mapGetters, mapActions} from 'vuex'
import axios from 'axios'
import {required, minLength, sameAs} from 'vuelidate/lib/validators'

export default {
  name: 'profile',
  components: {
    Orders,
  },
  validations: {
    old_password: {
      required, minLength: minLength(4)
    },
    new_password: {
      required, minLength: minLength(4)
    },
    confirm_new_password: {
      required,
      sameAs: sameAs('new_password')
    },
  },
  data() {
    return {
      isDis: true,
      login: '',
      contact_phone: '',
      bonuses: '',
      fioData: null,
      viewForm: true,
      editBtn: false,
      listBtn: true,
      fio: '',
      cityArr: [],
      postArr: [],
      deliveryArr: [],
      city_id: '',
      post_id: '',
      delivery_type: '',
      city_data: '',
      post_data: '',
      delivery_data: '',
      old_password: '',
      new_password: '',
      confirm_new_password: '',
      viewLoader: false,
      viewLoaderSave: false,
      personal_discount: null
    }
  },
  methods: {
    ...mapActions([
      'SIGN_OUT_USER',
    ]),
    list_orders() {
      this.viewForm = true
      this.editBtn = false
      this.listBtn = true
    },
    edit_profile() {
      this.viewForm = false
      this.listBtn = false
      this.editBtn = true
    },
    signOut() {
      this.SIGN_OUT_USER([])
      this.$router.push('/')
      this.$toasted.show('Вы вышли с личного кабинета').goAway(2000)
      return false
    },
    changePassword() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      } else {
        this.viewLoader = true
        let userData = {
          old_password: this.old_password,
          new_password: this.new_password,
          confirm_new_password: this.confirm_new_password,
        }
        axios({
          method: 'post',
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          url: this.$apiURI + 'public/user/update',
          data: {
            token: this.USER[0],
            user_data: JSON.stringify(userData)
          }
        })
            .then((response) => {
              this.viewLoader = false
              if (response.data.message == "Invalid old password") {
                this.$toasted.show('Неверный старый пароль!').goAway(2000)
                this.old_password = ''
                this.new_password = ''
                this.confirm_new_password = ''
                return false
              }
              if (response.data.message == "Updated successfully!") {
                this.$toasted.show('Пароль обновлен!').goAway(2000)
                this.old_password = ''
                this.new_password = ''
                this.confirm_new_password = ''
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    },
    saveDataUser() {
      this.viewLoaderSave = true
      let userData = {
        fio: this.fio,
        contact_phone: this.contact_phone,
        city_id: this.city_id,
        post_id: this.post_id,
        delivery_type: this.delivery_type,
      }
      axios({
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        url: this.$apiURI + 'public/user/update',
        data: {
          token: this.USER[0],
          user_data: JSON.stringify(userData)
        }
      })
          .then((response) => {
            this.viewLoaderSave = false
            if (response.data.message == "You enter wrong data,hacker") {
              this.$toasted.show('Заполните необходимые поля!').goAway(2000)
              return false
            }
            if (response.data.message == "Updated successfully!") {
              this.$toasted.show('Данные сохраненны').goAway(2000)
              // this.fio = ''
              // this.contact_phone = ''
              // this.city_id = ''
              // this.post_id = ''
              // this.delivery_type = ''
              this.getUser()
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    getUser() {
      axios({
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        url: this.$apiURI + 'public/user/get',
        data: {
          token: this.USER[0]
        }
      })
          .then((response) => {
            this.fio = response.data.fio
            this.fioData = response.data.fio
            this.login = response.data.login
            this.contact_phone = response.data.contact_phone
            this.bonuses = response.data.bonuses
            this.personal_discount = response.data.personal_discount
            this.city_data = response.data.city;
            this.post_data = response.data.post;
            this.delivery_data = response.data.delivery;
          })
          .catch((error) => {
            console.log(error);
          });
    },
    getCity() {
      axios({
        method: 'get',
        url: this.$apiURI + 'public/city/getall',
      })
          .then((response) => {
            this.cityArr = response.data
          });
    },
    getPost() {
      axios({
        method: 'get',
        url: this.$apiURI + 'public/post/getall',
      })
          .then((response) => {
            this.postArr = response.data
          });
    },
    getDelivery() {
      axios({
        method: 'get',
        url: this.$apiURI + 'public/delivery/getall',
      })
          .then((response) => {
            this.deliveryArr = response.data
          });
    },
    setCity () {
      this.city_id = this.cityArr.filter(city => {
        if (city.name === this.city_data)
          return city
      })[0].id || '';
    },
    setDelivery () {
      this.delivery_type = this.deliveryArr.filter(type => {
        if (type.name === this.delivery_data)
          return type
      })[0].id || '';
    },
    setPost () {
      this.post_id = this.postArr.filter(type => {
        if (type.name === this.post_data)
          return type
      })[0].id || '';
    },
  },
  mounted() {
    this.getCity()
    this.getPost()
    this.getDelivery()
    this.getUser()
  },
  computed: {
    ...mapGetters(['USER']),
  },
  watch: {
    city_data: function (val) {
      this.setCity(val);
    },
    delivery_data: function (val) {
      this.setDelivery(val);
    },
    post_data: function (val) {
      this.setPost(val);
    },
  }
}
</script>
<style scoped lang="less">
@baseMedia: 900px;
.profile::-webkit-scrollbar-track {
  background-color: transparent;
}

.profile::-webkit-scrollbar {
  width: 10px;
}

.profile::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background-color: #680;
}

.profile {
  width: 1200px;
  margin: 0 auto;
  height: 90vh;
  background: white;
  display: flex;
  justify-content: space-between;
  overflow-y: scroll;
  @media (max-width: @baseMedia) {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }

  .pc_orders {
    display: block;
    @media (max-width: @baseMedia) {
      display: none;
    }
  }

  .mob_orders {
    display: none;
    @media (max-width: @baseMedia) {
      display: block;
    }
  }

  .main_left_content {
    width: 70%;
    padding: 10px;
    @media (max-width: @baseMedia) {
      width: 100%;
    }

    .edit_user_data {
      width: 100%;
      padding: 10px;
      border: 2px dotted #ccc;
      display: flex;
      justify-content: space-between;
      @media (max-width: @baseMedia) {
        justify-content: center;
        flex-wrap: wrap;
      }

      .edit_user_data_l {
        width: 49%;
        padding: 10px;
        border: 1px solid #ccc;
        @media (max-width: @baseMedia) {
          width: 100%;
        }

        input {
          width: 100%;
          height: 40px;
          border: 1px solid #ccc;
          padding-left: 10px;
          margin-bottom: 10px;
        }

        select {
          width: 100%;
          padding: 10px;
          border: 1px solid #ccc;
          padding-left: 10px;
          margin-bottom: 10px;
        }

        button {
          width: 100%;
          height: 40px;
          outline: none;
          border: none;
          text-transform: uppercase;
          color: white;
          background: #3b5998;

          &:hover {
            background: #254588;
            transition: 1s;
          }
        }
      }

      .edit_user_data_r {
        width: 49%;
        padding: 10px;
        border: 1px solid #ccc;
        @media (max-width: @baseMedia) {
          width: 100%;
        }

        .error_input {
          border: 1px solid red;
        }

        .loader__color {
          color: #fff;
        }

        .error {
          color: red;
          font-size: 11px;
          margin-bottom: 10px;
        }

        input {
          width: 100%;
          height: 40px;
          border: 1px solid #ccc;
          padding-left: 10px;
          margin-bottom: 10px;
        }

        button {
          width: 100%;
          height: 40px;
          outline: none;
          border: none;
          text-transform: uppercase;
          color: white;
          background: #3b5998;

          &:hover {
            background: #254588;
            transition: 1s;
          }
        }
      }
    }
  }

  .main_rigth_content {
    width: 30%;
    display: flex;
    align-items: center;
    flex-direction: column;
    @media (max-width: @baseMedia) {
      width: 100%;
    }

    .main_rigth_content_base_block {
      width: 95%;
      border: 2px dotted #ccc;
      padding: 10px;
      margin-top: 10px;
      @media (max-width: @baseMedia) {
        padding: 5px;
      }

      p {
        @media (max-width: @baseMedia) {
          font-size: 12px;
        }
      }

      button {
        width: 100%;
        background: #668800;
        color: #fff;
        height: 40px;
        font-weight: bold;
        outline: none;

        &:hover {
          background: #546d07;
        }

        @media (max-width: @baseMedia) {
          height: 27px;
          font-size: 12px;
        }
      }

      .active_btn {
        background: #2e3e00;
      }
    }
  }
}
</style>